(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tt-sauna-faq"] && !Shopify.designMode) return;
  try {
    
(()=>{const sections=document.querySelectorAll('.tt-faq--reveal:not([data-tt-observed])');if(!sections.length)return;if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){sections.forEach(s=>s.classList.add('is-visible'));return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.12});sections.forEach(s=>{s.dataset.ttObserved='true';observer.observe(s)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-sauna-story"] && !Shopify.designMode) return;
  try {
    
(()=>{const sections=document.querySelectorAll('.tt-story--reveal:not([data-tt-observed])');if(!sections.length)return;if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){sections.forEach(s=>s.classList.add('is-visible'));return}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.12});sections.forEach(s=>{s.dataset.ttObserved='true';observer.observe(s)})})();

  } catch(e) { console.error(e); }
})();
})();
